import { City } from '@/app/modules/city/core/type'
import { PaginatedRequest } from '@/app/common/utils/pagination/types'
import { ChecklistImage } from '@/app/modules/checklist-image/core/type'

/**
 * Describes the object for creating an question.
 */
export interface ChecklistHeaderCreateParams {
  hours_meter: number
  chassis: string
  date: string
  user_id: number
  header_request_id?: number
  target?: string
  origin?: string
  origin_id?: number
  destination_id?: number
  destination?: string
  product_id: number
  type: HeaderTypeEnum
  client_name?: string
  client_email?: string
  client_phone?: string
}

export interface ChecklistHeader {
  id: number

  hours_meter: number

  chassis: string

  type: HeaderTypeEnum

  origin_id?: number
  origin?: City

  destination_id?: number
  destination?: City

  date: Date

  status: StatusEnum

  user_id: number

  target?: string

  maintenance_observation?: string

  product_id: number

  header_request_id?: number

  client_name?: string
  client_email?: string
  client_phone?: string

  ChecklistModels: ChecklistModel[]
  UserModel: UserModel
  ProductModel: ProductModel
}

export enum StatusEnum {
  DONE = 'done',
  IN_PROGRESS = 'in_progress',
  CANCELED = 'canceled',
  NOT_PROCEED = 'not_proceed'
}

export enum HeaderTypeEnum {
  NEW = 'new',
  TRANSFER_START = 'transfer_start',
  TRANSFER_DONE = 'transfer_done',
  USED = 'used',
  VEHICLE = 'vehicle',
  MAINTENANCE = 'maintenance',
  AUCTION = 'auction'
}

interface ChecklistImageModel extends ChecklistImage {}

interface ChecklistQuestionModel {
  question: string
}

interface ChecklistModel {
  answer: string
  ChecklistQuestionModel: ChecklistQuestionModel
  ChecklistImageModels: ChecklistImageModel[]
}

interface UserModel {
  name: string
  email: string
}

interface ProductModel {
  name: string
  image: string
}

export interface ChecklistHeaderFindAllParams extends PaginatedRequest {
  companyId?: number
  type?: string
}
export interface ChecklistHeaderFindAllResponse extends ChecklistHeader {}

export interface ChecklistHeaderUpdateParams {
  hours_meter: number
  chassis: string
  maintenance_observation?: string
  client_name?: string
  client_email?: string
  client_phone?: string
}

export interface ChecklistHeaderUpdateResponse extends ChecklistHeader {
  id: number
  type: HeaderTypeEnum
}
